export default __webpack_public_path__ + "static/char-s-08-chs-8ad734243ec8ea7691ca013ecfa21dbb.webp";